<template>
    <div id="testmap">
        <BGMap ref="bgmap" @location="onLocation" @zoomchange="onZoomChange" @mapmove="onMapMove"  @selectitem="onSelectItem"></BGMap>

        <EnterpriseDetail ref="detail" :model="selectItem" :pixel="selectPixel" v-if="showDetail" 
            @close="onCloseEnterpriseDetail" @navigation="onNavigation" @navigationclose="onNavigationClose" ></EnterpriseDetail>

        <div class="sider-left">
            <div class="area-bar box-shadow">
                <el-button icon="el-icon-location-outline" size="small" @click="showCitySelect = !showCitySelect">{{areaName}}</el-button>
                <span class="count">为您找到<span class="num">{{ list.length }}</span>家匹配的企业</span>
                <span class="search-icon" @mouseenter="enterSearchIcon" ><i class="el-icon-search"></i></span>

                <transition name="fade">
                    <div class="search-bar box-shadow" v-if="showSearch" @mouseleave="leaveSearchIcon">
                        <el-input class="search-text" ref="elSearch" placeholder="请输入搜索内容" @input="searchEnterprise" v-model="searchWord" >
                            <i slot="suffix" class="el-input__icon el-icon-search"></i>
                        </el-input>
                    </div>
                </transition>
            </div>

            <div class="view-bar box-shadow">
                <CitySelector class="box-shadow" @select="onSelectCity" v-if="showCitySelect" ></CitySelector> 
                <div class="box-card" v-if="!showSearchResult" >
                    <div class="header clearfix" @click="toggleViewbar">
                        <span>可视区域内为您找到<span class="num">{{ viewList.length }}</span>家企业</span>
                        <i style="float: right; margin-top:5px;" :class="['el-icon-arrow-up', showViewbar ? 'arrow-active' : '']" type="text"></i>
                    </div>
                    <div class="cont" v-show="showViewbar">
                        <div :class="['item', item.id == selectItem.id ? 'active' : '']" @click="onSelectItem(item)"
                          v-for="item in mapPageList" :key="item.id">
                            <div class="title">{{item.title}}</div>
                            <div class="addr">{{item.address}}</div>
                        </div>
                        <el-pagination class="pagination" background layout="prev, pager, next" 
                            :total="mapTotal" :page-size="mapPageSize" @current-change="changePage"
                        ></el-pagination>
                    </div>
                </div>

                <div class="box-card search-result" v-if="showSearchResult">
                    <div class="header clearfix">
                        <span><span class="kw">{{ searchWord}}</span> 共搜索到 <span class="num">{{ searchList.length }}</span>家企业</span>
                        <i @click="closeSearchBar" style="float: right; margin-top:5px;" class="el-icon-close" type="text"></i>
                    </div>
                    <div class="cont">
                        <div :class="['item', item.id == selectItem.id ? 'active' : '']" @click="onSelectItem(item)"
                          v-for="item in searchList" :key="item.id">
                            <div class="title" v-html="formatSearchTitle(item.title)"></div>
                            <div class="addr">{{item.address}}</div>
                        </div>
                        <!-- <el-pagination class="pagination" background layout="prev, pager, next" 
                            :total="total" :page-size="pageSize" @current-change="changePage"
                        ></el-pagination> -->
                    </div>
                </div>
            </div>
        </div> <!-- left end -->

        <div class="sider-right">
            <div class="tool-bar">
                <el-button class="btn-me" type="info" size="small" plain circle title="我的位置" @click="setUserPosition" icon="el-icon-location"></el-button>
                <el-button-group>
                    <el-button size="small" :type="isLoadNet ? 'primary' : 'default'" icon="iconfont icon-lukuang" @click="toggleLoadNet">路况</el-button>
                    <el-button size="small" :type="isSatellite ? 'primary' : 'default'" icon="iconfont icon-weixing" @click="toggleSetallite">卫星</el-button>
                </el-button-group>
            </div>
            
        </div>
    </div>
</template>

<script>
import BGMap from '../enterpriseInc/bgmap';
import EnterpriseDetail from '../enterpriseInc/enterprise-detail';
import CitySelector from '../enterpriseInc/city-selector';
import notify from '../../utils/notify';
export default {
    components:{
        BGMap, EnterpriseDetail, CitySelector
    },
    data(){
        return {
									title:"智能推荐-推荐企业地图",
									userdata:{},
            token: '',
            mapUtil: null,
            position: [],
            userInfo: {},
            showViewbar: false,
            list: [],
            viewList: [],
            mapPageList: [],
            mapPage: 1,
            mapPageSize: 10,
            mapTotal: 1,
            selectItem: {},
            selectPixel: null,
            showDetail: false,
            showCitySelect: false,
            areaId: 0,
            areaName: '',
            driving: null,
            isLoadNet: false,
            isSatellite: false,
            searchWord: '',
            showSearch: false,
            showSearchResult: false,
            searchList: [],
            searchTimerId: 0,
        }
    },
    mounted(){
        // this.token = this.$route.query.token;
        // this.$user.setToken(this.token);
								this.getuserinfor();
        this.mapUtil = this.$refs.bgmap.getMapUtil();
    },
    methods:{
					//获取用户信息
					getuserinfor() {
						let dataddd = sessionStorage.getItem('userData') ? sessionStorage.getItem('userData') : localStorage.getItem('userData');
						if (typeof(dataddd) == 'object') {
							this.userdata = dataddd;
						} else {
							this.userdata = JSON.parse(dataddd);
						} 
						this.token = this.userdata.token;
						// this.$user.setToken(this.token);
					}, 
        loadData(areaId){ 
									var ajaxurl=this.$api.cyl.map.entlistbycity() + '?area=' + areaId; 
										this.$axios.get(ajaxurl, {
											headers: {
												AuthToken: this.userdata.token
											}
										}).then(res => {
														// console.log(res);
														var data = res.data;
														this.list = data.list || [];
														this.setViewList();
										});
        },
        onSelectCity(city){
									console.log('abc')
            if(city.id != this.areaId){
                this.areaId = city.id;
                this.areaName = city.name;
                this.mapUtil.setCity(city.name, city);
                this.loadData(city.id);
            }
            this.showCitySelect = false;
        },
        onLocation({position, area}){
            console.log('index', position, area);
            this.position = position;
            // this.$user.setPosition(position);
            this.mapUtil.setZoomAndCenter(14, position);
            //获取用户信息和公司信息
												
            // this.$axios.get(this.$api.cyl.map.entlistbycity({area})).
												var ajaxurl=this.$api.cyl.map.entlistbycity() + '?area=' + area; 
												this.$axios.get(ajaxurl, {
													headers: {
														AuthToken: this.userdata.token
													}
												}).then(res => {
                // console.log(res );
                var data = res.data;
                var userInfo = {...data.data, total: data.totalRecord};
                var list = data.list;
                //console.log(userInfo, list);
                //this.$user.setUserInfo(userInfo);
                this.userInfo = userInfo;
                this.areaName = userInfo.areaName;
                this.areaId = userInfo.city;
                this.list = list ? list :[]; 
                this.setViewList();
            });
        },
        onZoomChange(zoom){
            this.setViewList();
            // if(this.showDetail){
            //     this.selectedPixel = this.$refs.bgmap.refreshMap(this.selectItem);
            // }
        },
        onMapMove(center){
            this.setViewList();
        },
        onCloseEnterpriseDetail(){
            this.showDetail = false;
            this.selectItem = {};
            this.selectPixel = {};
        },
        onSelectItem(data){
									console.log('bac',data)
            if(data.id != this.selectItem.id){
                this.mapUtil.moveTo([data.lng, data.lat]);
                this.selectItem = data;
                this.showDetail = true;
                this.selectPixel = this.$refs.bgmap.showSelectItem(data);
            }
        },
        onNavigation(type){
            console.log('navigation', type);
            this.driving = this.mapUtil.navigation({
                type, 
                from: this.position, 
                to:[this.selectItem.lng, this.selectItem.lat], 
                city: this.userInfo.areaName,
                panel: 'navigationPanel',
                callback: success => {
                    this.$refs.detail.onNavigationComplete(success);
                }
            });
        },
        onNavigationClose(){
            if(this.driving){
                this.driving.clear();
            }
        },
        toggleViewbar(){
            this.showViewbar = !this.showViewbar;
        },
        setViewList(){
            if(!this.list || this.length == 0 || this.showSearchResult){
                return;
            }
            //var mapUtil = this.$refs.bgmap.getMapUtil();
            this.viewList = this.mapUtil.getViewList(this.list);
            this.$refs.bgmap.setData(this.viewList);
            this.changePage(1);
            this.mapTotal = this.viewList.length;
        },
        setSearchList(){
            this.$refs.bgmap.setSearchData(this.searchList);
        },
        setUserPosition(){
            this.mapUtil.moveTo(this.position);
        },
        changePage(page){
            this.mapPage = page;
            var start = (page - 1) * this.mapPageSize;
            var end = start + this.mapPageSize;
            this.mapPageList = this.viewList.filter((o, i) => i >= start && i < end);
            //console.log(this.pageList);
        },
        toggleLoadNet(){
            this.isLoadNet = !this.isLoadNet;
            if(this.isLoadNet){
                this.mapUtil.addLoadNet();
            }else{
                this.mapUtil.removeLoadNet();
            }
        },
        toggleSetallite(){
            this.isSatellite = !this.isSatellite;
            if(this.isSatellite){
                this.mapUtil.addSatellite();
            }else{
                this.mapUtil.removeSatellite();
            }
        },
        enterSearchIcon(){
            //console.log('enter');
            this.showSearch = true;
            setTimeout(() => {
                this.$refs.elSearch.focus();
            }, 500);
        },
        leaveSearchIcon(){
            //console.log('leave');
            this.showSearch = this.showSearchResult || false;
        },
        searchEnterprise(kw){
            clearTimeout(this.searchTimerId);
            this.showSearchResult = kw != '';
            if(this.showSearchResult){
                this.searchList = this.list.filter(x => x.title.indexOf(kw) >= 0);
            }else{
                this.searchList = [];
            }
            this.searchTimerId = setTimeout(_ => {
                this.setSearchList();
            }, 1000);
        },
        formatSearchTitle(title){
            return title.replace(this.searchWord, '<span class="word">' + this.searchWord + '</span>');
        },
        closeSearchBar(){
            this.showSearch = false;
            this.showSearchResult = false;
            this.searchWord = '';
            this.searchList = [];
            this.setViewList();
        }
    }
}
</script>
<style lang="scss" scoped>
.box-shadow{
    background:#fff; border-radius:4px;  box-shadow:0 0 8px rgba(0, 0, 0, .1);
}
body .el-card__header{
    padding:13px 20px;
}
body .fade-enter-active{
    transition: width 2s;
}
body .word{
    color:#c00; font-weight: bold;
}
.sider-left{
    position:absolute; left:20px; top:20px; font-size:14px; text-align:left; width:380px; color:#000;
}
.area-bar{
    padding:10px;  position: relative;
    .count{
        margin:0 10px;
    }
    .search-icon{
        float: right; margin-top:7px; margin-right:6px; font-size:18px;
        &:hover{
            color:#39f;
        }
    }
    .el-icon-close{
        font-size:18px;
    }
    .search-bar{
        position: absolute; left:0; top:0; width:98%; height:100%;
        //display:none;
        .search-text{
            margin:5px 4px;
        }
        
    }
}
.num, .kw{
    color:rgb(16, 111, 189); font-weight: bold; margin:0 8px;
}
.tool-bar{
    position: absolute; top:20px; right:20px; text-align:left;
    .btn-me{
        color:#c00; margin-right:20px; padding:3px; font-size:22px;
        i{
            font-size:24px;
        }
        &:hover{
            background:#e4f1ff; color:#f00;
        }
    }
}
</style>
<style scoped lang="scss">
#testmap{ 
			position: relative;
}

.kw{
    color:#c00;
}
.el-icon-arrow-up{
    transition-duration:0.2s;
}
.arrow-active{
    transform:rotate(180deg); transition-duration:0.2s;
}

.view-bar{
    margin-top:12px; position: relative;
    .box-card{
        .header{
            padding:15px 20px;
        }
        .cont{
            padding:5px 0; border-top:1px solid #eee; height:600px; overflow-y: scroll;
            .item{
                cursor: default; padding:0 20px;
            }
            .active{
                background:#eee;
                .title{
                    color:#f50;
                }
            }
        }
        .title{
            font-size:16px; padding:10px 0; font-weight: bold; color:rgba(9, 22, 49, 0.842);
        }
        .addr{
            font-size:12px; color:#555; border-bottom:1px solid #eee; padding:5px 0 10px;
        }
    }
    .pagination{
        padding:10px 0;
    }
}


</style>